import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginRoutingModule } from './login-routing.module';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';

import { FormComponent } from './form/form.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { RecoverComponent } from './recover/recover.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';


import { CoreModule } from 'src/app/core/core.module';
@NgModule({ declarations: [
        FormComponent,
        RecoverComponent
    ], imports: [CoreModule,
        CommonModule,
        LoginRoutingModule,
        CardModule,
        ButtonModule,
        CheckboxModule,
        InputTextModule,
        PasswordModule,
        FormsModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class LoginModule { }
